export function formatDateShort(dateString: string | Date | undefined): string {
  if (!dateString) return "N/A";
  try {
    const date = typeof dateString === "string" ? new Date(dateString) : dateString;
    if (Number.isNaN(date.getTime())) return "N/A";
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return `${months[date.getMonth()]} ${date.getDate().toString().padStart(2, "0")}, ${date.getFullYear()}`;
  } catch {
    return "N/A";
  }
}

export function formatCoursePrice(price?: number, isFree?: boolean): string {
  if (isFree) return "Free";
  if (price === undefined || price === null) return "N/A";
  const priceNum = typeof price === "number" ? price : Number(price) || 0;
  return `$${priceNum.toFixed(2)}`;
}

export function getModuleCount(moduleCount?: number, modules?: any[]): number {
  if (typeof moduleCount === "number") return moduleCount;
  if (Array.isArray(modules)) return modules.length;
  return 0;
}